<section class="content">
  <div class="card" style="    padding: 24px;">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>Select Date</mat-label>
        <input type="date" [(ngModel)]="selected_date" (ngModelChange)="changeEvent()" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>Select Session</mat-label>
        <mat-select [(ngModel)]="selected_session_id" class="main-border-class" (ngModelChange)="changeEvent()">
          <mat-option [value]="session.id" *ngFor="let session of sessions">{{session['name']}}</mat-option>
        </mat-select>
      </div>
      <div class="col-2">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 9%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="selected_date == null || selected_session_id == null">Get</button>
      </div>
      <div class="col-2" *ngIf="!is_document_available">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
        </mat-progress-spinner>
      </div>
      <div class="col-2" *ngIf="document_file !== null" style="margin-top: 25px;">
        <button mat-raised-button class="button-class" (click)="downloadClicked()"><i class="material-icons">
            picture_as_pdf
          </i> Download report</button>
      </div>
      <!-- <div class="col-2" *ngIf="document_file !== null"  style="margin-top: 25px;">
        <button mat-button class="button-class"><i class="material-icons">
            get_app
          </i> Download Excel</button>
      </div> -->
    </div>

    <!-- <div class="row">
      <div class="col-6"></div>
      <div class="col-6">
        <div class="row">
          <div class="col-4">
          </div>

        </div>
      </div>
    </div> -->
  </div>
  <iframe [src]="pdf_data" width="100%" height="800" *ngIf="document_file!== null"></iframe>
</section>
